import React from 'react';
import io from 'socket.io-client';

export const socket = io(window.location.origin, {
    auth: { token: localStorage.getItem('token') },
});

export const SocketContext = React.createContext<any>(socket);
